import React from "react";
import { AddBeneficiaryContainer } from "../../../containers";

const AddBeneficiary = (props) => {
  return <AddBeneficiaryContainer {...props} />;
};

export default AddBeneficiary;
